export default __webpack_public_path__ + "static/media/rambouillet01.a95dc214.jpg";